"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("navigation-view", className, styles.root),
        menu: styling_1.mergeStyles("navigation-view-menu", styles.menu),
        menuGlass: styling_1.mergeStyles("navigation-view-menu-glass", styles.menuGlass),
        menuContent: styling_1.mergeStyles("navigation-view-menu-content", styles.menuContent),
        title: styling_1.mergeStyles("navigation-view-title", styles.title),
        menuContentNear: styling_1.mergeStyles("navigation-view-menu-content-near", styles.menuContentNear),
        menuContentFar: styling_1.mergeStyles("navigation-view-menu-far", styles.menuContentFar),
        menuItemContainer: styling_1.mergeStyles("navigation-view-menu-item-container", styles.menuItemContainer),
        menuItem: styling_1.mergeStyles("navigation-view-menu-item", styles.menuItem),
        menuItemTitleContainer: styling_1.mergeStyles("navigation-view-menu-item-title-container", styles.menuItemTitleContainer),
        menuItemIconContainer: styling_1.mergeStyles("navigation-view-menu-item-icon-container", styles.menuItemIconContainer),
        menuItemIconAlt: styling_1.mergeStyles("navigation-view-menu-item-icon-alt", styles.menuItemIconAlt),
        main: styling_1.mergeStyles("navigation-view-main", styles.main)
    };
});
exports.getClassNames = getClassNames;
